import { Action, Dispatch } from 'redux';
import {
  requestQuote,
  getPolicyScanResult,
  IRequestQuotePayload,
} from 'services';
import { IAnyPolicyScan } from 'types';

export enum Types {
  MARKET_SCAN_RESULT_LOADED = 'MARKET_SCAN_RESULT_LOADED',
  UPDATE_MARKET_SCAN_RESULT_LOCAL = 'UPDATE_MARKET_SCAN_RESULT_LOCAL',
  SHOW_HOW_TO_VIDEOS_POPUP = 'SHOW_HOW_TO_VIDEOS_POPUP',
  HIDE_HOW_TO_VIDEOS_POPUP = 'HIDE_HOW_TO_VIDEOS_POPUP',
  SET_PURCHASE_FLOW_ACTIVE = 'SET_PURCHASE_FLOW_ACTIVE',
}

export interface IMarketScanResultLoaded extends Action {
  type: Types.MARKET_SCAN_RESULT_LOADED;
  data: IAnyPolicyScan;
}

export interface IUpdateMarketScanResultLocal extends Action {
  type: Types.UPDATE_MARKET_SCAN_RESULT_LOCAL;
  data: IAnyPolicyScan;
}

export interface IShowHowToVideosPopup extends Action {
  type: Types.SHOW_HOW_TO_VIDEOS_POPUP;
}

export interface IHideHowToVideosPopup extends Action {
  type: Types.HIDE_HOW_TO_VIDEOS_POPUP;
}

export interface ISetPurchaseFlowActive extends Action {
  type: Types.SET_PURCHASE_FLOW_ACTIVE;
  active: boolean;
}

export const MarketScanResultLoaded = (
  data: IAnyPolicyScan,
): IMarketScanResultLoaded => ({
  type: Types.MARKET_SCAN_RESULT_LOADED,
  data,
});

export const UpdateMarketScanResultLocal = (
  data: IAnyPolicyScan,
): IUpdateMarketScanResultLocal => ({
  type: Types.UPDATE_MARKET_SCAN_RESULT_LOCAL,
  data,
});

export const ShowHowToVideosPopup = (): IShowHowToVideosPopup => ({
  type: Types.SHOW_HOW_TO_VIDEOS_POPUP,
});

export const HideHowToVideosPopup = (): IHideHowToVideosPopup => ({
  type: Types.HIDE_HOW_TO_VIDEOS_POPUP,
});

export const SetPurchaseFlowActive = (
  active: boolean,
): ISetPurchaseFlowActive => ({
  type: Types.SET_PURCHASE_FLOW_ACTIVE,
  active,
});

export const RequestQuoteAndRefresh =
  (payload: IRequestQuotePayload) => async (dispatch: Dispatch) => {
    try {
      await requestQuote(payload);

      // Re-fetch the policy scan so UI reflects quoteRequested: true
      const refreshed = await getPolicyScanResult(
        payload.policyScanId,
        payload.policyId,
        payload.quoteRequestExperiment,
      );
      dispatch(MarketScanResultLoaded(refreshed.data));

      return { success: true };
    } catch (error: any) {
      const errorMsg =
        error?.response?.data?.error ||
        'Failed to request quote. Please try again.';
      return { success: false, error: errorMsg };
    }
  };